import React from "react";
import { NumberInput } from "react-admin";
import PlayerStats from "./PlayerStats";

const VolleyballPlayerStats = ({ s }) => {
  return (
    <PlayerStats s={s}>
      <NumberInput label="Kills" source={s("kills")} />
      <NumberInput label="Aces" source={s("aces")} />
      <NumberInput label="Blocks" source={s("blocks")} />
      <NumberInput label="Digs" source={s("digs")} />
      <NumberInput label="Assists" source={s("assists")} />
    </PlayerStats>
  );
};

export default VolleyballPlayerStats;
